import { createActions } from 'redux-actions'

export const INIT_REGISTER_INFO = "INIT_REGISTER_INFO";

export const REQUEST_REGISTER_START = "REQUEST_REGISTER_START";
export const REQUEST_REGISTER_SUCCESS = "REQUEST_REGISTER_SUCCESS";
export const REQUEST_REGISTER_FAIL = "REQUEST_REGISTER_FAIL";

export const {

  initRegisterInfo,
  requestRegisterStart,
  requestRegisterSuccess,
  requestRegisterFail,

} = createActions({

  [INIT_REGISTER_INFO]: (req) => ({ req }),

  [REQUEST_REGISTER_START]: (req) => ({ ...req }),
  [REQUEST_REGISTER_SUCCESS]: (res) => ({ res }),
  [REQUEST_REGISTER_FAIL]: (res) => ({ res }),

})


